import React, { useCallback } from "react";

//
//component
//redux
//selector
//actions
import { useSignUp } from "hook/useAuth";
//utils
//hook
//str
const ButtonResent = ({ setLoading, disabled }) => {
  // -------------------------- VAR -----------------------------
  const { onGetCode } = useSignUp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleClick = () => {
    onGetCode({ disabled, setLoading });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return (
    <a
      className="mx-1 underline hover:text-black hover:underline"
      onClick={handleClick}
    >
      Gửi Mã
    </a>
  );
};
export default ButtonResent;
